// P1-013: Top-right resource display bar (FLOP / AGI)
import { useEffect, useRef, useState } from 'react';
import { usePlayerStore } from '@/shared/stores/playerStore';
import { CurrencyDisplay } from '@/shared/ui/CurrencyDisplay';

export function ResourceBar() {
  const flop = usePlayerStore((s) => s.flop);
  const agi = usePlayerStore((s) => s.agi);
  const reputation = usePlayerStore((s) => s.reputation);

  const [flopPulse, setFlopPulse] = useState(false);
  const [agiPulse, setAgiPulse] = useState(false);
  const [repPulse, setRepPulse] = useState(false);
  const prevFlop = useRef(flop);
  const prevAgi = useRef(agi);
  const prevRep = useRef(reputation);

  useEffect(() => {
    if (flop !== prevFlop.current) {
      setFlopPulse(true);
      const t = setTimeout(() => setFlopPulse(false), 300);
      prevFlop.current = flop;
      return () => clearTimeout(t);
    }
  }, [flop]);

  useEffect(() => {
    if (agi !== prevAgi.current) {
      setAgiPulse(true);
      const t = setTimeout(() => setAgiPulse(false), 300);
      prevAgi.current = agi;
      return () => clearTimeout(t);
    }
  }, [agi]);

  useEffect(() => {
    if (reputation !== prevRep.current) {
      setRepPulse(true);
      const t = setTimeout(() => setRepPulse(false), 300);
      prevRep.current = reputation;
      return () => clearTimeout(t);
    }
  }, [reputation]);

  return (
    <div className="resource-bar">
      <div className={`resource-bar__item ${flopPulse ? 'resource-bar__item--pulse' : ''}`}>
        <CurrencyDisplay type="flop" amount={flop} />
      </div>
      <div className={`resource-bar__item ${agiPulse ? 'resource-bar__item--pulse' : ''}`}>
        <CurrencyDisplay type="agi" amount={agi} />
      </div>
      <div className={`resource-bar__item ${repPulse ? 'resource-bar__item--pulse' : ''}`}>
        <span style={{
          color: 'var(--color-element-blue, #4fc3f7)',
          fontFamily: 'var(--font-mono)',
          fontSize: 'var(--font-size-md)',
          fontWeight: 600,
          display: 'inline-flex',
          alignItems: 'center',
          gap: '4px',
        }}>
          ★ {reputation}
        </span>
      </div>
    </div>
  );
}
